const sliderInit = (isUpdate) => {
  if (document.querySelectorAll('.js-media-list') && document.querySelectorAll('.js-media-list').length > 0) {
    document.querySelectorAll('.js-media-list').forEach((elem, index) => {
      let slider = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 1,
        autoHeight: false,
        speed: 500,
        navigation: {
          nextEl: '.product .product__slider-nav .swiper-button-next',
          prevEl: '.product .product__slider-nav .swiper-button-prev',
        },
        pagination: {
          el: '.product .product__pagination',
          type: 'bullets',
          clickable: true,
        },
        thumbs: {
          swiper:
            document.querySelectorAll('.js-media-sublist').length > 0
              ? document.querySelectorAll('.js-media-sublist')[index]?.swiper
              : '',
        },
        on: {
          afterInit: function (swiper) {},
          slideChangeTransitionStart: function () {
            if (document.querySelector('.js-media-sublist')) {
              document
                .querySelector('.js-media-sublist')
                .swiper.slideTo(document.querySelector('.js-media-list').swiper.activeIndex);
            }
          },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;

            if (document.querySelector('.js-popup-slider') && document.querySelector('.js-popup-slider').swiper) {
              document.querySelector('.js-popup-slider').swiper.slideTo(this.activeIndex);
            }
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector('model-viewer')) {
              this.slides[this.activeIndex]
                .querySelector('.shopify-model-viewer-ui__button--poster')
                .removeAttribute('hidden');
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector('model-viewer')) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector('model-viewer')
                  .classList.contains('shopify-model-viewer-ui__disabled')
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = 'swiper-slide';
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          slider.update();
        }, 800);
      }
    });
  }
};

const subSliderInit = (isUpdate, margin) => {
  if (document.querySelectorAll('.js-media-sublist') && document.querySelectorAll('.js-media-sublist').length > 0) {
    document.querySelectorAll('.js-media-sublist').forEach((elem, index) => {
      const slides = elem.querySelectorAll('.product__media-subitem');
      const slidesAmount = slides.length;
      const slidesPerView = slidesAmount < 3 ? slidesAmount : 3;
      let subSlider = new Swiper(elem, {
        slidesPerView: slidesPerView,
        spaceBetween: 8,
        direction: 'horizontal',
        freeMode: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        on: {
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
        breakpoints: {
          1200: {
            spaceBetween: margin,
            slidesPerView: slidesPerView,
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          subSlider.update();
        }, 800);
      }
    });
  }
};

const popupSliderInit = (isUpdate) => {
  if (document.querySelector('.js-popup-slider')) {
    let popupSlider = new Swiper(document.querySelector('.js-popup-slider'), {
      slidesPerView: 1,
      navigation: {
        nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
        prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
      },
      pagination: {
        el: '.product-media-modal .product__pagination',
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: function () {
          if (
            document.querySelector('.product__outer--grid-gallery') ||
            document.querySelector('.product__outer--stacked-gallery')
          ) {
            document.querySelectorAll('.product__media-list .product__media-toggle').forEach((elem, index) => {
              elem.addEventListener('click', (e) => {
                if (document.querySelector('.js-popup-slider') && document.querySelector('.js-popup-slider').swiper) {
                  document.querySelector('.js-popup-slider').swiper.slideTo(index);
                }
              });
            });
          }
        },
        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
          document.querySelector('.product-media-modal__content').classList.remove('zoom');
        },
        touchMove: function () {
          document.querySelector('.product-media-modal__content').classList.remove('zoom');
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex].querySelector('model-viewer')) {
            this.slides[this.activeIndex]
              .querySelector('.shopify-model-viewer-ui__button--poster')
              .removeAttribute('hidden');
          }
        },
        touchStart: function () {
          if (this.slides[this.activeIndex].querySelector('model-viewer')) {
            if (
              !this.slides[this.activeIndex]
                .querySelector('model-viewer')
                .classList.contains('shopify-model-viewer-ui__disabled')
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = 'swiper-slide';
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });

    if (isUpdate) {
      setTimeout(function () {
        popupSlider.update();
      }, 800);
    }
  }
};

if (navigator.userAgent.indexOf('iPhone') > -1) {
  document
    .querySelector('[name=viewport]')
    .setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (!video.closest('.hero__image') && !video.closest('.multirow__video')) video.pause();
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus && !elementToFocus.classList.contains('card-focused')) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    // this.updateVat();
    // this.vatToggle = document.querySelector("toggle-vat input");
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    // this.vatToggle.addEventListener("change", function () {
    //   this.updateVat();
    // });
    // this.VatPrices = document.querySelectorAll(".cart-item__vat span.price");
    // this.input.addEventListener(
    //   "change",
    //   function () {
    //     setTimeout(() => {
    //       this.updateVat();
    //     }, 1000); // Delay of 500ms
    //   }.bind(this)
    // );

    this.querySelectorAll('button').forEach((button) => {
      this.setMinimumDisable();

      button.addEventListener('click', this.onButtonClick.bind(this));

      // button.addEventListener(
      //   "click",
      //   function () {
      //     setTimeout(() => {
      //       this.updateVat();
      //     }, 1000);
      //   }.bind(this)
      // );
    });
    var eventList = ['paste', 'input'];

    for (event of eventList) {
      this.input.addEventListener(event, function (e) {
        const numberRegex = /^0*?[1-9]\d*$/;

        if (numberRegex.test(e.currentTarget.value) || e.currentTarget.value === '') {
          e.currentTarget.value;
        } else {
          e.currentTarget.value = 1;
        }

        if (e.currentTarget.value === 1 || e.currentTarget.value === '') {
          this.previousElementSibling.classList.add('disabled');
        } else {
          this.previousElementSibling.classList.remove('disabled');
        }
      });
    }

    this.input.addEventListener('focusout', function (e) {
      if (e.currentTarget.value === '') {
        e.currentTarget.value = 1;
      }
    });
  }
  setMinimumDisable() {
    if (this.input.value == 1) {
      this.querySelector('button[name="minus"]').classList.add('disabled');
    } else {
      this.querySelector('button[name="minus"]').classList.remove('disabled');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    this.setMinimumDisable();
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) => {
      if (this.querySelector('.toggle-scheme-button') === button) return;
      if (this.querySelector('.header__localization-button') === button) return;
      if (this.querySelector('.header__localization-lang-button') === button) return;
      if (!button.classList.contains('mobile-facets__footer__button'))
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      if (button.classList.contains('mobile-facets__footer__button'))
        button.addEventListener('click', this.closeMenuDrawer.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      this.header = this.header || document.querySelector('.shopify-section-header');
      const main = document.querySelector('main');
      if (
        main.querySelectorAll('.shopify-section')[0].classList.contains('section--has-overlay') &&
        !this.header.classList.contains('animate')
      ) {
      }
    }
  }

  onFocusOut(event) {
    /*
      setTimeout(() => {
        if (
          this.mainDetailsToggle.hasAttribute("open") &&
          !this.mainDetailsToggle.contains(document.activeElement)
        )
          this.closeMenuDrawer(event);
      });
     */
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.headerWrapper = document.querySelector('.header-wrapper');
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.headerWrapper.getBoundingClientRect().top)}px`
    );
    const main = document.querySelector('main');
    if (main.querySelectorAll('.shopify-section')[0].classList.contains('section--has-overlay')) {
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll('body > quick-add-modal').forEach((el) => {
      if (el.hasAttribute('open')) {
        isOpen = true;
      }
    });

    if (!isOpen) {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
    }

    const images = document.querySelector('.product-media-modal__content');

    if (images) {
      images.classList.remove('zoom');
    }
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
    if (this.getAttribute('data-autoplay')) {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      /*this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      ).focus();*/

      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.getAttribute('data-autoplay')) {
              if (deferredElement.nodeName == 'VIDEO') {
                let playPromise = entry.target.play();
                if (playPromise !== undefined) {
                  playPromise.then((_) => {}).catch((error) => {});
                }
              } else {
                if (entry.target.classList.contains('js-youtube')) {
                  entry.target.contentWindow.postMessage(
                    '{"event":"command","func":"' + 'playVideo' + '","args":""}',
                    '*'
                  );
                } else {
                  entry.target.contentWindow.postMessage('{"method":"play"}', '*');
                }
              }
              //entry.target.play()
            }
          } else {
            if (deferredElement.nodeName == 'VIDEO') {
              entry.target.pause();
            } else {
              if (entry.target.classList.contains('js-youtube')) {
                entry.target.contentWindow.postMessage(
                  '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
                  '*'
                );
              } else {
                entry.target.contentWindow.postMessage('{"method":"pause"}', '*');
              }
            }
          }
        });
      });

      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      //if (focus) deferredElement.focus();

      if (deferredElement.nodeName == 'VIDEO' || deferredElement.nodeName == 'IFRAME') {
        // force autoplay for safari

        if (this.classList.contains('video-section__media')) {
          if (deferredElement.nodeName == 'VIDEO') {
            let playPromise = deferredElement.play();
            if (playPromise !== undefined) {
              playPromise.then((_) => {}).catch((error) => {});
            }
          }

          videoObserver.observe(deferredElement);
        } else {
          deferredElement.play();
        }
      }

      if (
        this.closest('.swiper')?.swiper.slides[this.closest('.swiper').swiper.activeIndex].querySelector('model-viewer')
      ) {
        if (
          !this.closest('.swiper')
            .swiper.slides[this.closest('.swiper').swiper.activeIndex].querySelector('model-viewer')
            .classList.contains('shopify-model-viewer-ui__disabled')
        ) {
          this.closest('.swiper').swiper.params.noSwiping = true;
          this.closest('.swiper').swiper.params.noSwipingClass = 'swiper-slide';
        }
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      if (this.currentVariant?.featured_media) {
        this.updateMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.js-radio-colors'));

    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      })
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      this.currentVariant = this.getVariantData().find((variant) => {
        this.options.sort();
        variant.options.sort();

        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === 'none' || styles.visibility === 'hidden';
  }

  updateMedia(mediaId) {
    const currentSection = document.querySelector(`[data-section="main-${this.dataset.section}"]`);
    this.mediaList = currentSection.querySelector('.product__media-list');
    const activeMedia = this.mediaList.querySelector(`[data-media-id="${mediaId}"]`);
    this.mediaList.querySelectorAll('[data-media-id]').forEach((element) => {
      element.classList.remove('active');
    });
    if (activeMedia) activeMedia.classList.add('active');

    const swiperWrappers = document.querySelectorAll('.product__media-wrapper');

    swiperWrappers.forEach((elem) => {
      if (!this.isHidden(elem)) {
        const newMedia = elem.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (elem.querySelector('.js-media-list')) {
          elem
            .querySelector('.js-media-list')
            .swiper.slideTo(elem.querySelector('.js-media-list').swiper.slides.indexOf(newMedia));
        }
      }
    });
  }

  updateURL() {
    if (!this.classList.contains('featured-product-radios')) {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__controls')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        if (input.tagName === 'OPTION') {
          input.innerText = input.getAttribute('value');
        } else if (input.tagName === 'INPUT') {
          input.classList.remove('disabled');
        }
      } else {
        if (input.tagName === 'OPTION') {
          input.innerText = window.variantStrings.unavailable_with_option.replace(
            '[value]',
            input.getAttribute('value')
          );
        } else if (input.tagName === 'INPUT') {
          input.classList.add('disabled');
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const colorNameSource = html.getElementById(
          `ColorName-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const colorNameDestination = document.getElementById(`ColorName-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }
        if (colorNameSource && colorNameDestination) colorNameDestination.innerHTML = colorNameSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        window.dispatchEvent(new CustomEvent('vat-update'));
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
        input.disabled = false;
      } else {
        input.classList.add('disabled');
        input.disabled = true;
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
class LogoSelector extends HTMLElement {
  constructor() {
    super();
    this.vatBTN = document.querySelector('#toggle-vat');
    this.dropZone = this.querySelector('.upload_file__instructions');
    this.notes = document.querySelector('#costumizerNote');
    this.fileUploader = this.querySelector('.logo__uplouder input');
    this.logoUploader = this.querySelector('.logo__uplouder');
    this.instructionContent = this.dropZone.innerHTML;
    this.logoUplouderInput = this.querySelector('.logo__uplouder input');
    this.customizationBtns = document.querySelectorAll('.logo_customization__body .btns__wrapper button');
    this.totalSaving = document.querySelector('.total_saving__amount span');
    this.existingLogos = this.querySelectorAll('.logos__images .logo_image__input');
    this.productForm = document.querySelector('.product__form');
    this.allInputs = this.querySelectorAll(`input[form="${this.productForm.id}"]`);
    this.addToCartBtn = document.querySelector('.product-form__submit');
    this.anotherLogo = this.closest('.logo__position').innerHTML;
    this.exestingLogosPopupBtn = this.querySelector('.file__uplouder button');
    this.exestingLogosPopup = this.querySelector('.logos__popup');
    this.exestingLogosPopupCloseBtn = this.querySelector('.logos__popup .close__btn');
    this.addAnotherBtnBlockBtns = this.querySelectorAll('.add_another_logo_block__btns button');
    this.overlay = document.createElement('div');
    this.overlay.className = 'overlay';
    this.textLogoBtns = this.querySelectorAll('.text_logo__btns button');
    this.allLogoPostions = this.querySelectorAll('.logo_position__body input');
    this.addTextBlock = this.querySelector('.add_text__wrapper');
    this.quantitySelcetorsInputs = document.querySelectorAll('.quantity__selcetor input');
    this.productFormSubmit = document.querySelector('.product-form__submit');
    this.allHiddenTextLogo = document.querySelectorAll('.hidden_text__logo');
    this.allHiddenfees = document.querySelectorAll('.hidden__fees');
    this.quantitySelcetorsButtons = document.querySelectorAll('.quantity__selcetor button');
    this.allQuantitySellectors = document.querySelectorAll('.quantity__selcetor');
    this.allHiddenCustomizationType = document.querySelectorAll('.quantity__selcetor .hidden_customization__type');
    this.allHiddenLogoFiles = document.querySelectorAll('.quantity__selcetor .hidden__file');
    this.allHiddenfileNotes = document.querySelectorAll('.quantity__selcetor .hidden_file_link_or__text');
    this.allHiddenBundleId = document.querySelectorAll('.quantity__selcetor .bundle__id');
    this.fontStyle = this.querySelector('.font__style');
    this.orderSummaryBlock = document.querySelector('.order_summary__block');

    // this.vatBTN.addEventListener('change',this.calculateTotalPrices())
  }
  connectedCallback() {
    this.calculateTotalPrices();
    this.initializeDragAndDrop();
    this.initializeDropZoneListeners();
    this.chooseFileFromExisitingFiles();
    this.initializeModalListeners();
    this.updateAnotherLogoPositions();
    this.handleTextLogo();
    this.addAnotherLogo();
    this.removeAnotherLogoPosition();
    this.handleAnotherLogoInputsChange();
    this.handleAnotherLogoInputsChangeToCalcPrice();
    this.changeQuantity();
    this.handleCustomizationFile();
    this.updateSelectedHiddenLogoFile();
    this.updateFormBeforeSubmit();
    if (this.vatBTN) {
      this.vatBTN.addEventListener('change', () =>
        setTimeout(
          function () {
            this.calculateTotalPrices();
          }.bind(this),
          10
        )
      );
    }
  }
  getNumbersFromString(inputString) {
    const numbers = inputString.match(/\d+(\.\d+)?/g);
    if (!numbers) return [];
    return numbers.map((num) => (num.includes('.') ? parseFloat(num) : parseInt(num, 10)));
  }
  oneTimeFeesSetup() {
    let oneTimeFeesArr = [];
    const allLogoSelector = document.querySelectorAll('logo-selector');

    if (allLogoSelector.length >= 1) {
      allLogoSelector.forEach((el) => {
        let oneTimeFees = 0;
        const logosPopup = el.querySelector('.logos__popup');
        const activeCostumization = el.closest('variant-selector')?.querySelector('.btns__wrapper .btn__blue');

        if (!activeCostumization) return;

        // Check if user chose to reuse existing logo - if so, set one-time fees to 0
        const isReusingExistingLogo = el.getAttribute('reuse-existing-logo') === 'true';

        if (isReusingExistingLogo) {
          oneTimeFees = 0;
          el.setAttribute('one-time-fees', '0');
        } else if (!logosPopup || !logosPopup.querySelector('input:checked')) {
          const selectedInput = el.closest('logo-selector')?.querySelector('.logo_position__body input:checked');
          if (selectedInput) {
            if (activeCostumization.getAttribute('name') === 'printing') {
              oneTimeFees = +selectedInput.getAttribute('printing-price')?.replace('£', '') || 0;
              el.closest('logo-selector').setAttribute(
                'one-time-fees',
                +selectedInput.getAttribute('printing-price')?.replace('£', '')
              );
            } else if (activeCostumization.getAttribute('name') === 'embroidery') {
              oneTimeFees = +selectedInput.getAttribute('embroidering-price')?.replace('£', '') || 0;
              el.closest('logo-selector').setAttribute(
                'one-time-fees',
                +selectedInput.getAttribute('embroidering-price')?.replace('£', '')
              );
            }
          }
        } else {
          el.closest('logo-selector').removeAttribute('one-time-fees');
        }
        oneTimeFeesArr.push(oneTimeFees);
      });
    }
    const totalOne_timeFees = oneTimeFeesArr.reduce((sum, val) => sum + val, 0);
    // Store in closest variant-selector
    const variantSelector = this.closest('variant-selector');
    if (variantSelector) {
      variantSelector.setAttribute('total-one-time-fees', totalOne_timeFees);
      if (variantSelector.calcTotalPrice) {
        variantSelector.calcTotalPrice();
      }
    }
    return totalOne_timeFees;
  }
  updateFormBeforeSubmit() {
    this.productFormSubmit.addEventListener('click', () => {
      const index = +this.getAttribute('index');
      const date = new Date().getTime();
      this.updateHiddenBundleIds(date);
      this.updateNotesBundleId(date);
      const positions = this.getCheckedLogoPositions();
      this.updateCustomizationFields(index, positions);
      this.updateQuantitySelectors(index);
    });
  }

  updateHiddenBundleIds(date) {
    this.allHiddenBundleId.forEach((el) => {
      el.value = date;
    });
  }

  updateNotesBundleId(date) {
    this.notes.setAttribute('bundle-id', `${date}`);
  }

  getCheckedLogoPositions() {
    const allCheckedLogoPositions = document.querySelectorAll('.logo_position__body input:checked');
    let positions = '';
    allCheckedLogoPositions.forEach((el, idx) => {
      if (!el.disabled) {
        positions += idx === allCheckedLogoPositions.length - 1 ? el.value : `${el.value}, `;
      }
    });
    return positions;
  }

  updateCustomizationFields(index, positions) {
    this.allQuantitySellectors.forEach((el) => {
      this.updateCustomizationType(positions);
      this.updateLogoDetails(index);
    });
  }

  updateCustomizationType(positions) {
    this.customizationBtns.forEach((el2) => {
      if (el2.classList.contains('btn__blue')) {
        const customizationType = el2.getAttribute('name');
        this.allHiddenCustomizationType.forEach((el3) => {
          if (customizationType === 'no-customisation') {
            el3.value = '';
          } else if (customizationType === 'printing') {
            el3.value = `Printing | ${positions}`;
          } else {
            el3.value = `Embroidery | ${positions}`;
          }
        });
      }
    });
  }

  updateLogoDetails(index) {
    this.textLogoBtns.forEach((el2) => {
      if (el2.classList.contains('btn__blue')) {
        const logoType = el2.getAttribute('name');
        if (logoType === 'upload-file-later') {
          this.handleUploadFileLater(index);
        } else if (logoType === 'type-text') {
          this.handleTypeText(index);
        }
      }
    });
  }

  handleUploadFileLater(index) {
    this.fileUploader.required = false;
    this.allHiddenfileNotes.forEach((el3) => {
      if (+el3.getAttribute('index') === index) el3.value = 'file will be uploaded later';
    });
    this.allHiddenTextLogo.forEach((el3) => {
      if (+el3.getAttribute('index') === index) el3.value = '';
    });
    this.allHiddenLogoFiles.forEach((el3) => {
      if (+el3.getAttribute('index') === index) el3.value = '';
    });
  }

  handleTypeText(index) {
    if (this.hasAttribute('reuse-existing-logo') && this.getAttribute('reuse-existing-logo') === 'true') {
      return;
    }

    let artworkText = this.addTextBlock.querySelector('textarea').value;
    let fontStyle = '';
    this.fontStyle.querySelectorAll('.font_style__btns input').forEach((el3) => {
      if (el3.checked) fontStyle = el3.value;
    });
    this.allHiddenTextLogo.forEach((el3) => {
      if (+el3.getAttribute('index') === index) {
        el3.value = `${artworkText} | ${fontStyle}`;
      }
    });
  }

  updateQuantitySelectors() {
    document.querySelector('variant-selector').setAttribute('one-time-fees', this.oneTimeFeesSetup());
    this.allQuantitySellectors.forEach((el) => {
      const inputQuantity = +el.querySelector('.input__quantity').value;
      const allInputs = el.querySelectorAll('input');

      if (inputQuantity === 0) {
        allInputs.forEach((input) => {
          input.disabled = true;
        });
      } else {
        allInputs.forEach((input) => {
          input.disabled = !input.value;
        });
      }
    });
  }

  updateSelectedHiddenLogoFile() {
    this.fileUploader.addEventListener('change', (event) => {
      this.textLogoBtns.forEach((el2) => {
        el2.disabled = true;
      });
      const index = +this.getAttribute('index');
      const selectedFile = this.fileUploader.files;
      this.allHiddenLogoFiles.forEach((el) => {
        if (+el.getAttribute('index') === index) {
          el.files = selectedFile;
        }
      });
    });
  }
  handleCustomizationFile() {
    const handleBtn = () => {
      this.customizationBtns.forEach((el) => {
        el.classList.remove('btn__blue');
        el.classList.add('btn_border__blue');
      });
    };
    const handleStep4 = () => {
      let activeBtn = null;
      this.customizationBtns.forEach((el) => {
        if (el.classList.contains('btn__blue')) activeBtn = el;
      });
      if (activeBtn.getAttribute('name') === 'printing') {
        this.allLogoPostions.forEach((el) => {
          el.required = true;
        });
        this.logoUplouderInput.required = true;
        this.orderSummaryBlock.querySelector('.one_time_fees__costs').classList.remove('d-none');
        this.orderSummaryBlock.querySelector('.logo__costs').classList.remove('d-none');
        this.closest('.logo_positions__wrapper').classList.remove('d-none');

        this.closest('.logo_positions__wrapper')
          .querySelectorAll('.active_btn__text')
          .forEach((e, i) => {
            e.innerText = `Printing Position ${i + 1}:`;
          });
        this.closest('.logo_positions__wrapper').querySelector('.add_another_logo__block .normal__text').innerText =
          'Add Another Printing Position:';
        this.closest('.logo_positions__wrapper')
          .querySelectorAll('.chosen_position__span')
          .forEach((el) => (el.innerText = 'Upload Your Logo For Printing Position '));
        this.initializeFlickity(this.closest('.logo_positions__wrapper').querySelector('.logo_position__body'));
      } else if (activeBtn.getAttribute('name') === 'embroidery') {
        this.orderSummaryBlock.querySelector('.one_time_fees__costs').classList.remove('d-none');
        this.orderSummaryBlock.querySelector('.logo__costs').classList.remove('d-none');
        this.logoUplouderInput.required = true;
        this.allLogoPostions.forEach((el) => {
          el.required = true;
        });
        this.closest('.logo_positions__wrapper').classList.remove('d-none');

        this.closest('.logo_positions__wrapper')
          .querySelectorAll('.active_btn__text')
          .forEach((e, i) => {
            e.innerText = `Embroidery Position ${i + 1}:`;
          });
        this.closest('.logo_positions__wrapper').querySelector('.add_another_logo__block .normal__text').innerText =
          'Add Another Embroidery Position:';
        this.closest('.logo_positions__wrapper')
          .querySelectorAll('.chosen_position__span')
          .forEach((el) => (el.innerText = 'Upload Your Logo For Embroidery Position '));
        this.initializeFlickity(this.closest('.logo_positions__wrapper').querySelector('.logo_position__body'));
      } else {
        this.orderSummaryBlock.querySelector('.one_time_fees__costs').classList.add('d-none');
        this.orderSummaryBlock.querySelector('.logo__costs').classList.add('d-none');
        this.logoUplouderInput.required = false;
        this.closest('.logo_positions__wrapper').classList.add('d-none');
        this.allLogoPostions.forEach((el) => {
          el.required = false;
        });
      }
      setTimeout(
        function () {
          this.calculateTotalPrices();
        }.bind(this),
        10
      );
    };
    this.customizationBtns.forEach((el) => {
      el.addEventListener('click', function () {
        handleBtn();
        el.classList.add('btn__blue');
        el.classList.remove('btn_border__blue');
        handleStep4();
      });
    });
  }
  changeQuantity() {
    this.quantitySelcetorsInputs.forEach((el) => {
      el.addEventListener('change', () => {
        setTimeout(
          function () {
            this.calculateTotalPrices();
          }.bind(this),
          10
        );
      });
    });
    this.quantitySelcetorsButtons.forEach((el) => {
      el.addEventListener('click', () => {
        setTimeout(
          function () {
            this.calculateTotalPrices();
          }.bind(this),
          10
        );
      });
    });
  }
  handleAnotherLogoInputsChangeToCalcPrice() {
    this.allLogoPostions.forEach((el) => {
      el.addEventListener('change', () => {
        setTimeout(
          function () {
            this.calculateTotalPrices();
          }.bind(this),
          10
        );
      });
    });
  }

  calculateTotalPrices() {
    const oneTimeFeesSetup = this.oneTimeFeesSetup();
    const currentPriceContainer = document.querySelector('.current__price span');
    const previosPriceContainer = document.querySelector('.prev__price span');
    const totalProductsQuantity = +document.querySelector('.color__sizes').getAttribute('data-quantity') || 0;

    let currentPrice = this.getCurrentTotalPrice(oneTimeFeesSetup);
    let previosPrice = this.getPreviousTotalPrice(oneTimeFeesSetup);

    const { totalLogoPrice, originalLogosPrices } = this.calculateLogoPrices(totalProductsQuantity);
    const variantSelector = this.closest('variant-selector');
    variantSelector.setAttribute('logo-costs', totalLogoPrice);
    // Trigger recalculation of total price in variant selector
    if (variantSelector.calcTotalPrice) {
      variantSelector.calcTotalPrice();
    }
    let logo__costs = this.orderSummaryBlock.querySelector('.logo__costs span span');
    if (logo__costs) logo__costs.innerText = parseFloat(totalLogoPrice).toFixed(2) || 0;
    this.updatePriceContainers(
      currentPriceContainer,
      previosPriceContainer,
      currentPrice,
      previosPrice,
      totalLogoPrice,
      originalLogosPrices
    );

    this.updateLogosAttributes(totalLogoPrice, originalLogosPrices);
    this.toggleFormSubmitButton(currentPriceContainer);
  }

  getCurrentTotalPrice(oneTimeFeesSetup) {
    return (+document.querySelector('.product__prices').getAttribute('current-total-price') || 0) + oneTimeFeesSetup;
  }

  getPreviousTotalPrice(oneTimeFeesSetup) {
    return (+document.querySelector('.product__prices').getAttribute('prev-total-price') || 0) + oneTimeFeesSetup;
  }

  calculateLogoPrices(totalProductsQuantity) {
    let totalLogoPrice = 0;
    let originalLogosPrices = 0;

    const activeOption = this.getActiveCustomizationOption();

    if (activeOption.getAttribute('name') === 'printing') {
      this.setLogoPrices('.product_offers_Peiniting__body', totalProductsQuantity);
    } else if (activeOption.getAttribute('name') === 'embroidery') {
      this.setLogoPrices('.product_offers_Embroidery__body', totalProductsQuantity);
    } else {
      this.resetLogoPrices();
    }

    this.closest('variant-selector')
      .querySelectorAll('.logo_position__body')
      .forEach((el) => {
        originalLogosPrices += +el.getAttribute('original-logo-price') || 0;
        totalLogoPrice += +el.getAttribute('logo-price') || 0;
      });

    return { totalLogoPrice, originalLogosPrices };
  }

  getActiveCustomizationOption() {
    let activeOption = null;
    this.customizationBtns.forEach((el) => {
      if (el.classList.contains('btn__blue')) activeOption = el;
    });
    return activeOption;
  }

  setLogoPrices(selector, totalProductsQuantity) {
    const activePriceElement = this.closest('variant-selector').querySelector(
      `${selector} .active_product__offer .discount__price`
    );
    const defaultPriceElement = this.closest('variant-selector').querySelector(`${selector} .discount__price`);

    this.querySelector('.logo_position__body').setAttribute(
      'logo-price',
      (+activePriceElement?.innerText.replace('£', '') || 0) * totalProductsQuantity
    );
    this.querySelector('.logo_position__body').setAttribute(
      'original-logo-price',
      (+defaultPriceElement?.innerText.replace('£', '') || 0) * totalProductsQuantity
    );
  }

  resetLogoPrices() {
    this.querySelector('.logo_position__body').setAttribute('logo-price', 0);
    this.querySelector('.logo_position__body').setAttribute('original-logo-price', 0);
  }

  updatePriceContainers(
    currentPriceContainer,
    previosPriceContainer,
    currentPrice,
    previosPrice,
    totalLogoPrice,
    originalLogosPrices
  ) {
    const calculatePriceWithVat = (price, includeVat) => (includeVat ? price * 1.2 : price);

    const includeVat = this.vatBTN?.checked;

    const currentPriceWithVat = calculatePriceWithVat(currentPrice, includeVat);
    const totalLogoPriceWithVat = calculatePriceWithVat(totalLogoPrice, includeVat);
    const previosPriceWithVat = calculatePriceWithVat(previosPrice, includeVat);
    const originalLogosPricesWithVat = calculatePriceWithVat(originalLogosPrices, includeVat);

    currentPriceContainer.innerText = (currentPriceWithVat + totalLogoPriceWithVat).toFixed(2);

    previosPriceContainer.innerText = (previosPriceWithVat + originalLogosPricesWithVat).toFixed(2);

    this.totalSaving.innerText = (
      previosPriceWithVat +
      originalLogosPricesWithVat -
      (currentPriceWithVat + totalLogoPriceWithVat)
    ).toFixed(2);
    this.orderSummaryBlock.querySelector('.vat__costs span span').innerText = parseFloat(
      (currentPrice + totalLogoPriceWithVat) * 0.2
    ).toFixed(2);

    this.orderSummaryBlock.querySelector('.without_vat__costs span span').innerText = parseFloat(
      currentPrice + totalLogoPriceWithVat
    ).toFixed(2);
  }

  updateLogosAttributes(totalLogoPrice, originalLogosPrices) {
    this.closest('variant-selector').querySelector('.product__prices').setAttribute('logos-price', totalLogoPrice);
    this.closest('variant-selector')
      .querySelector('.product__prices')
      .setAttribute('original-logos-price', originalLogosPrices);
  }

  toggleFormSubmitButton(currentPriceContainer) {
    if (currentPriceContainer.innerText === '0.00') {
      this.productFormSubmit.disabled = true;
    } else {
      this.productFormSubmit.disabled = false;
    }
  }

  removeAnotherLogoPosition() {
    const logoPositionsWrapper = document.querySelector('.logo_positions__wrapper');
    this.addAnotherBtnBlockBtns.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (button.getAttribute('name') === 'not-required') {
          setTimeout(
            function () {
              this.calculateTotalPrices();
            }.bind(this),
            10
          );
          const clickedLogoPosition = event.target.closest('.logo__position');
          const currentLogoPositionNumber = +clickedLogoPosition.querySelector('.logo_position__number').innerText;

          const allLogoPositions = logoPositionsWrapper.querySelectorAll('.logo__position');

          allLogoPositions.forEach((position) => {
            const positionNumber = +position.querySelector('.logo_position__number').innerText;

            if (positionNumber > currentLogoPositionNumber) {
              position.remove();
            }
          });
          this.addAnotherBtnBlockBtns.forEach((btn) => {
            btn.disabled = false;
          });
          button.disabled = true;
        }
      });
    });
  }
  updateAnotherLogoPositions() {
    const logoPositionWrapper = this.closest('.logo_positions__wrapper');
    if (!logoPositionWrapper) return;

    const allAnotherLogoPositions = logoPositionWrapper.querySelectorAll('logo-selector');
    allAnotherLogoPositions.forEach((el, idx) => {
      const index = idx + 1;

      el.classList.add(`logo-selector--${index}`);
      el.setAttribute('index', index);

      const selectedButton = document
        .querySelector('.logo_customization__body .logo__btn.btn__blue')
        ?.getAttribute('name');

      const printingMethod = selectedButton === 'embroidery' ? 'Embroidery' : 'Printing';

      // select .active_btn__text
      el.querySelector('.active_btn__text').innerText = `${printingMethod} Position : ${index}`;

      el.querySelectorAll('.logo_position__number').forEach((el2) => (el2.innerHTML = index));

      const updateInputAndLabelAttributes = (inputs, labels, suffix) => {
        inputs.forEach((input, i) => {
          input.id += suffix;

          const currentName = input.getAttribute('name') || '';
          input.setAttribute('name', currentName + suffix);

          if (labels[i]) {
            const currentFor = labels[i].getAttribute('for') || '';
            labels[i].setAttribute('for', currentFor + suffix);
          }
        });
      };

      const existingImagesInputs = el.querySelectorAll('.logos__images input');
      const existingImagesLabels = el.querySelectorAll('.logos__images label');
      updateInputAndLabelAttributes(existingImagesInputs, existingImagesLabels, index);

      const logoPositionInputs = el.querySelectorAll('.logo_position__body input');
      const logoPositionLabels = el.querySelectorAll('.logo_position__body label');
      updateInputAndLabelAttributes(logoPositionInputs, logoPositionLabels, index);

      const fontStyleBtnsInputs = el.querySelectorAll('.font_style__btns input');
      const fontStyleBtnsLabels = el.querySelectorAll('.font_style__btns label');
      updateInputAndLabelAttributes(fontStyleBtnsInputs, fontStyleBtnsLabels, index);

      const anotherLogoUploaderInput = el.querySelector('.logo__uplouder input');
      const anotherLogoUploaderLabel = el.querySelector('.logo__uplouder label');
      if (anotherLogoUploaderInput && anotherLogoUploaderLabel) {
        anotherLogoUploaderInput.id += index;
        const currentFor = anotherLogoUploaderLabel.getAttribute('for') || '';
        anotherLogoUploaderLabel.setAttribute('for', currentFor + index);
      }

      this.initializeFlickity(el.querySelector('.logo_position__body'));

      el.querySelectorAll('.logo_position__number').forEach((el) => (el.innerText = `${index}`));
    });
  }
  disableSelectedPosition() {
    const allLogoPostions = Array.from(document.querySelectorAll('.logo_position__body input'));
    allLogoPostions.forEach((el) => {
      el.disabled = false;
    });
    const checkedInputs = allLogoPostions.filter((input) => input.checked);
    const uncheckedInputs = allLogoPostions.filter((input) => !input.checked);
    checkedInputs.forEach((el) => {
      uncheckedInputs.forEach((el2) => {
        if (el.value === el2.value) el2.disabled = true;
      });
    });
  }
  handleAnotherLogoInputsChange() {
    const allLogoPostions = this.closest('.logo_positions__wrapper').querySelectorAll('.logo_position__body input');
    allLogoPostions.forEach((el) => {
      el.addEventListener('change', () => {
        this.disableSelectedPosition();
        if (el.checked === true)
          el.closest('.logo__position').querySelector('.chosen_position__value').innerText = el.value;
      });
    });
  }
  addAnotherLogo() {
    const handleBtn = () => {
      this.addAnotherBtnBlockBtns.forEach((el) => {
        el.classList.remove('btn__blue');
        el.classList.add('btn_border__blue');
      });
    };
    const handAnotherLogo = () => {
      const tempContainer = document.createElement('div');
      tempContainer.classList.add('another_logo__container');
      tempContainer.classList.add('logo__position');
      tempContainer.innerHTML = `${this.anotherLogo}`;
      tempContainer.querySelectorAll('.logo_position__body  input').forEach((el) => (el.required = true));
      tempContainer.querySelector('.logo__uplouder input').required = true;
      let activeBtn = null;
      this.addAnotherBtnBlockBtns.forEach((el) => {
        if (el.classList.contains('btn__blue')) activeBtn = el;
      });
      if (activeBtn && activeBtn.getAttribute('name') === 'add-position') {
        this.closest('.logo_positions__wrapper').appendChild(tempContainer);
        this.updateAnotherLogoPositions();

        // Attach existing logo handler to the new position
        const newLogoSelector = tempContainer.querySelector('logo-selector');
        if (newLogoSelector && window.attachExistingLogoHandlerToNewPosition) {
          window.attachExistingLogoHandlerToNewPosition(newLogoSelector);
        }

        // Restore button states immediately after processing
        const existingLogoSelectors = this.closest('.logo_positions__wrapper').querySelectorAll('logo-selector');
        existingLogoSelectors.forEach((selector) => {
          if (selector.getAttribute('reuse-existing-logo') === 'true') {
            const yesBtn = selector.querySelector('#use-existing-logo-yes, [id*="use-existing-logo-yes"]');
            const noBtn = selector.querySelector('#use-existing-logo-no, [id*="use-existing-logo-no"]');

            if (yesBtn) {
              yesBtn.classList.add('btn__blue');
              yesBtn.classList.remove('btn_border__blue');
            }
            if (noBtn) {
              noBtn.classList.remove('btn__blue');
              noBtn.classList.add('btn_border__blue');
            }
          }
        });

        this.addAnotherBtnBlockBtns.forEach((el) => {
          el.disabled = false;
        });
        activeBtn.disabled = true;
      }
    };
    this.addAnotherBtnBlockBtns.forEach((el) => {
      const logoPositionsWrapper = document.querySelectorAll('.logo__position').length;
      const maxLogoPositionNumber = this.querySelectorAll('.logo_position__body label').length;
      if (logoPositionsWrapper < maxLogoPositionNumber) {
        el.addEventListener('click', () => {
          handleBtn();
          el.classList.add('btn__blue');
          el.classList.remove('btn_border__blue');
          handAnotherLogo();
          this.disableSelectedPosition();
        });
      } else {
        this.addAnotherBtnBlockBtns.forEach((el) => {
          el.disabled = true;
        });
      }
    });
  }
  initializeFlickity(el) {
    if (el) {
      this.carousel = new Flickity(el, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        prevNextButtons: true,
      });
      setTimeout(() => {
        this.carousel.resize();
      }, 10);
    }
  }
  chooseFileFromExisitingFiles() {
    if (this.allHiddenLogoFiles) {
      const applyTheactiveLogo = () => {
        const index = +this.getAttribute('index');
        let activeLogo = null;
        this.existingLogos.forEach((el) => {
          if (el.checked) activeLogo = el.nextElementSibling.querySelector('img');
        });
        this.showImagePreview(activeLogo.getAttribute('src'), activeLogo.getAttribute('file-name'));
        this.allHiddenLogoFiles.forEach((el) => {
          this.fileUploader.required = false;
          if (+el.getAttribute('index') === index) {
            el.type = 'text';
            el.setAttribute('name', el.name.replace(`Artwork`, `Artwork_existing_file`));
            el.value = activeLogo.getAttribute('file-name');
          }
        });
        this.textLogoBtns.forEach((el2) => {
          el2.disabled = true;
        });
        this.calculateTotalPrices();
      };
      this.existingLogos.forEach((el) => {
        el.addEventListener('change', function () {
          applyTheactiveLogo();
        });
      });
    }
  }
  initializeModalListeners() {
    const modalConfig = [];
    if (this.exestingLogosPopupBtn) {
      modalConfig.push({
        btn: this.exestingLogosPopupBtn,
        modal: this.exestingLogosPopup,
      });
      modalConfig.push({
        btn: this.exestingLogosPopupCloseBtn,
        modal: this.exestingLogosPopup,
      });
    }
    modalConfig.forEach(({ btn, modal }) => {
      btn.addEventListener('click', this.toggleModal.bind(this, modal, null));
    });

    this.overlay.addEventListener('click', this.toggleModal.bind(this, null, true));
  }
  toggleModal(modal, isOverlay) {
    if (isOverlay) {
      if (this.exestingLogosPopup) {
        this.exestingLogosPopup.classList.remove('show');
      }
      this.overlay.classList.remove('show');
      document.body.style.overflow = 'auto';
      return;
    }

    if (!document.body.contains(this.overlay)) {
      document.body.appendChild(this.overlay);
    }

    modal.classList.toggle('show');
    this.overlay.classList.toggle('show');

    document.body.style.overflow = modal.classList.contains('show') ? 'hidden' : 'auto';
  }
  removeSelectedFile(event) {
    const index = +this.getAttribute('index');
    const rect = this.querySelector('.uploaded_logo__wrapper svg rect');
    const paths = this.querySelectorAll('.uploaded_logo__wrapper svg path');

    if (event.target === rect || event.target === paths[0] || event.target === paths[1]) {
      event.stopPropagation();
      event.preventDefault();
      this.fileUploader.required = true;
      this.dropZone.innerHTML = this.instructionContent;
      this.logoUplouderInput.value = null;
      this.textLogoBtns.forEach((el2) => {
        el2.disabled = false;
      });
      this.existingLogos.forEach((el) => {
        el.checked = false;
      });
      this.allHiddenLogoFiles.forEach((el) => {
        if (+el.getAttribute('index') === index) {
          el.value = null;
        }
      });
      this.calculateTotalPrices();
    }
  }

  initializeDropZoneListeners() {
    this.dropZone.addEventListener('click', this.removeSelectedFile.bind(this));
  }

  initializeDragAndDrop() {
    if (!this.dropZone || !this.fileUploader) return;

    const allowedFileTypes = [
      'image/jpeg',
      'image/png',
      'image/gif',
      'application/pdf',
      'image/svg+xml',
      'image/ai',
      'image/eps',
      'image/psd',
    ];

    this.dropZone.addEventListener('dragover', (event) => {
      event.preventDefault();
      this.dropZone.classList.add('dragover');
    });

    this.dropZone.addEventListener('dragleave', () => {
      this.dropZone.classList.remove('dragover');
    });

    this.dropZone.addEventListener('drop', (event) => {
      event.preventDefault();
      this.dropZone.classList.remove('dragover');

      const files = event.dataTransfer.files;
      if (files.length > 0) {
        const file = files[0];

        if (allowedFileTypes.includes(file.type)) {
          this.fileUploader.files = files;
          if (file.type.startsWith('image/')) {
            this.showImagePreview(file);
            this.existingLogos.forEach((el) => {
              el.checked = false;
            });
            this.textLogoBtns.forEach((el2) => {
              el2.classList.remove('btn__blue');
              el2.classList.add('btn_border__blue');
              el2.disabled = true;
            });
            if (this.addTextBlock) {
              this.addTextBlock.classList.add('d-none');
              const textarea = this.addTextBlock.querySelector('textarea');
              if (textarea) {
                textarea.required = false;
                textarea.value = '';
              }
            }
            if (this.fontStyle) {
              this.fontStyle.classList.add('d-none');
              const fontInputs = this.fontStyle.querySelectorAll('input');
              fontInputs.forEach((input) => {
                input.required = false;
                input.checked = false;
              });
            }
          } else {
            this.updateDropZoneContent(file.name);
            this.textLogoBtns.forEach((el2) => {
              el2.classList.remove('btn__blue');
              el2.classList.add('btn_border__blue');
              el2.disabled = true;
            });
            if (this.addTextBlock) {
              this.addTextBlock.classList.add('d-none');
              const textarea = this.addTextBlock.querySelector('textarea');
              if (textarea) {
                textarea.required = false;
                textarea.value = '';
              }
            }
            if (this.fontStyle) {
              this.fontStyle.classList.add('d-none');
              const fontInputs = this.fontStyle.querySelectorAll('input');
              fontInputs.forEach((input) => {
                input.required = false;
                input.checked = false;
              });
            }
          }
          this.fileUploader.dispatchEvent(new Event('change'));
          this.calculateTotalPrices();
        } else {
          alert(
            'Invalid file type. Please upload one of the allowed file types. allowed file types:jpg, jpeg, png, gif, pdf, svg, ai, eps, psd,'
          );
        }
      }
    });

    this.fileUploader.addEventListener('change', () => {
      const files = this.fileUploader.files;
      if (files.length > 0) {
        const file = files[0];

        if (allowedFileTypes.includes(file.type)) {
          if (file.type.startsWith('image/')) {
            this.showImagePreview(file);
            this.existingLogos.forEach((el) => {
              el.checked = false;
            });
          } else {
            this.updateDropZoneContent(file.name);
          }
          this.textLogoBtns.forEach((el2) => {
            el2.classList.remove('btn__blue');
            el2.classList.add('btn_border__blue');
            el2.disabled = true;
          });
          if (this.addTextBlock) {
            this.addTextBlock.classList.add('d-none');
            const textarea = this.addTextBlock.querySelector('textarea');
            if (textarea) {
              textarea.required = false;
              textarea.value = '';
            }
          }
          if (this.fontStyle) {
            this.fontStyle.classList.add('d-none');
            const fontInputs = this.fontStyle.querySelectorAll('input');
            fontInputs.forEach((input) => {
              input.required = false;
              input.checked = false;
            });
          }
          this.calculateTotalPrices();
        } else {
          alert(
            'Invalid file type. Please upload one of the allowed file types. allowed file types:jpg, jpeg, png, gif, pdf, svg, ai, eps, psd,'
          );
          this.fileUploader.value = '';
        }
      }
    });
  }
  showImagePreview(fileOrSrc, fileName) {
    if (fileOrSrc instanceof File) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const imagePreview = `
                <div class="image_content__wrapper">
                    <div class="uploaded_logo__wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <rect x="0.5" width="24" height="24" rx="12" fill="#042049"/>
                            <path d="M8.96409 15.5359L16.0352 8.46484" stroke="#F5F6F5" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M8.96409 8.46409L16.0352 15.5352" stroke="#F5F6F5" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        <img src="${event.target.result}" alt="Uploaded Image" class="uploaded__logo">
                    </div>
                    <p class="file__name">${fileOrSrc.name}</p>
                </div>
            `;
        this.dropZone.innerHTML = imagePreview;
      };
      reader.readAsDataURL(fileOrSrc);
    } else {
      const imagePreview = `
            <div class="image_content__wrapper">
                <div class="uploaded_logo__wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                        <rect x="0.5" width="24" height="24" rx="12" fill="#042049"/>
                        <path d="M8.96409 15.5359L16.0352 8.46484" stroke="#F5F6F5" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M8.96409 8.46409L16.0352 15.5352" stroke="#F5F6F5" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                    <img src="${fileOrSrc}" alt="Uploaded Image" class="uploaded__logo">
                </div>
                <p class="file__name">${fileName.replace(
                  'https://cdn.shopify.com/s/files/1/0885/2222/8037/uploads/',
                  ''
                )}</p>
            </div>
        `;
      this.dropZone.innerHTML = imagePreview;
    }
  }
  updateDropZoneContent(content) {
    this.dropZone.innerHTML = `<p class="file__name">${content}</p>`;
  }

  handleTextLogo() {
    const handleBtn = (elem) => {
      this.textLogoBtns.forEach((el) => {
        if (el !== elem) {
          el.classList.remove('btn__blue');
          el.classList.add('btn_border__blue');
        }
      });
      if (elem.classList.contains('btn__blue')) {
        elem.classList.remove('btn__blue');
        elem.classList.add('btn_border__blue');
      } else if (elem.classList.contains('btn_border__blue')) {
        elem.classList.add('btn__blue');
        elem.classList.remove('btn_border__blue');
      }
    };
    const handletextLogo = () => {
      const activeBtn = Array.from(this.textLogoBtns).find((el) => el.classList.contains('btn__blue'));

      const toggleElements = (addTextBlockVisible, fontStyleVisible) => {
        this.addTextBlock.classList.toggle('d-none', !addTextBlockVisible);
        this.addTextBlock.querySelector('textarea').required = addTextBlockVisible;
        this.fontStyle.classList.toggle('d-none', !fontStyleVisible);
        this.fontStyle.querySelectorAll('.font_style__btns input').forEach((el) => (el.required = fontStyleVisible));
      };

      if (activeBtn) {
        const isTypeText = activeBtn.getAttribute('name') === 'type-text';
        toggleElements(isTypeText, isTypeText);

        // this.logoUploader.classList.add('d-none');
        this.fileUploader.disabled = false;
        if (this.exestingLogosPopupBtn) this.exestingLogosPopupBtn.disabled = false;
        this.logoUplouderInput.required = false;
      } else {
        this.logoUploader.classList.remove('d-none');
        this.fileUploader.disabled = false;
        if (this.exestingLogosPopupBtn) this.exestingLogosPopupBtn.disabled = false;
        this.logoUplouderInput.required = true;
        toggleElements(false, false);
      }
    };
    this.textLogoBtns.forEach((el) => {
      el.addEventListener('click', function () {
        handleBtn(el);
        handletextLogo();
      });
    });
  }
}
customElements.define('logo-selector', LogoSelector);

class FormUpdater extends HTMLElement {
  constructor() {
    super();
    this.notes = document.querySelector('#costumizerNote');
    this.allQuantityInputs = this.closest('variant-selector').querySelectorAll('.quantity__selcetor .input__quantity');
    this.allQuantityButtons = this.closest('variant-selector').querySelectorAll('.quantity__selcetor button');
    this.productFormSubmit = document.querySelector('.product-form__submit');
    this.allQuantitySellectors = document.querySelectorAll('.quantity__selcetor');
    this.allHiddenBundleId = document.querySelectorAll('.quantity__selcetor .bundle__id');
    this.productFormSubmit.disabled = true;
  }
  connectedCallback() {
    this.updateFormBeforeSubmit();
    this.updateFormBtn();
  }
  updateFormBtn() {
    const variantSelector = this.closest('variant-selector');

    this.allQuantityButtons.forEach((el) =>
      el.addEventListener('click', () => {
        setTimeout(() => {
          this.productFormSubmit.disabled = variantSelector.getTotalQuantity() <= 0;
        }, 0);
      })
    );

    this.allQuantityInputs.forEach((el) =>
      el.addEventListener('change', () => {
        setTimeout(() => {
          this.productFormSubmit.disabled = variantSelector.getTotalQuantity() <= 0;
        }, 0);
      })
    );
  }

  updateFormBeforeSubmit() {
    this.productFormSubmit.addEventListener('click', () => {
      const date = new Date().getTime();
      this.updateHiddenBundleIds(date);
      this.updateNotesBundleId(date);
      this.updateQuantitySelectors();
    });
  }

  updateHiddenBundleIds(date) {
    if (this.allHiddenBundleId) {
      this.allHiddenBundleId.forEach((el) => {
        el.value = date;
      });
    }
  }

  updateNotesBundleId(date) {
    this.notes.setAttribute('bundle-id', `${date}`);
  }

  updateQuantitySelectors() {
    let hasCustomization = false;
    const logoBody = document.querySelector('.logo_customization__body .btns__wrapper .btn__blue');
    if (logoBody) {
      logoBody.getAttribute('name') === 'no-customisation' ? (hasCustomization = false) : (hasCustomization = true);
    }

    document.querySelector('.color__sizes').setAttribute('has-customization', hasCustomization);
    document
      .querySelector('variant-selector')
      .setAttribute('one-time-fees', this.closest('variant-selector').getAttribute('total-one-time-fees') || 0);
    this.allQuantitySellectors.forEach((el) => {
      const inputQuantity = +el.querySelector('.input__quantity').value;
      const allInputs = el.querySelectorAll('input');

      if (inputQuantity === 0) {
        allInputs.forEach((input) => {
          input.disabled = true;
        });
      } else {
        allInputs.forEach((input) => {
          input.disabled = !input.value;
        });
      }
    });
  }
}
customElements.define('form-updater', FormUpdater);
class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.quantitySelectors = [];
    this.slides = [];
    this.flickityViewport = null;
    this.pricesCustomizationModalBtn = this.querySelector('.modal__btn');
    this.pricesCustomizationModal = this.querySelector('.product_offers__modal');
    this.pricesCloseBtn = this.querySelector('.close__btn');
    this.sizesCloseBtn = this.querySelector('.size_guide__header .close__btn');
    this.sizesModalBtn = this.querySelector('.size_guide_modal__btn');
    this.sizesModal = this.querySelector('.size_guide__modal');
    this.artworkCloseBtn = this.querySelector('.artwork_guide__modal .close__btn');
    this.allVariantBlocks = this.querySelectorAll('.product__quantity ');
    this.restOfferProduct = this.querySelector('.rest_offer__product');
    this.artworkModalBtn = this.querySelector('.artwork_modal__btn');
    this.artworkModal = this.querySelector('.artwork_guide__modal');
    this.overlay = document.createElement('div');
    this.overlay.className = 'overlay';
    this.productOffers = this.querySelectorAll('.product_offers__body .product__offer');
    this.colorSizes = this.querySelectorAll('.size-block-list');
    this.selectedColour = this.querySelector('p.product-form__group-name');
    this.modalProductOffers = this.querySelector('.product_offers__modal .product_offers__body .product__offer');
    this.productFormControlsGroup = this.querySelectorAll('.product-form__controls-group');
    this.checkboxes = [];
    this.productFormControlsGroup.forEach((group) => {
      const checkboxesInGroup = group.querySelectorAll('input[type="checkbox"]');
      this.checkboxes.push(...checkboxesInGroup);
    });
    this.prevTotalPrice = this.querySelector('.prev__price span');
    this.currentTotalPrice = this.querySelector('.current__price span');
    this.totalSaving = this.querySelector('.total_saving__amount span');
    this.toggleVat = document.querySelector('#toggle-vat');
    this.allInputs = this.querySelectorAll(".size-block-list input[type='number']");
    this.orderSummaryBlock = this.querySelector('.order_summary__block');
    this.colabsableContentBtn = this.querySelector('.collapsible-content__btn');
    this.colorSizesBlock = this.querySelector('.color__sizes');
    this.customLogoBlock = this.querySelector('.logo__customization');
  }

  connectedCallback() {
    this.initializeCheckboxListenersFirstTime();
    this.setMaxValuesForInputs();
    this.initializeElements();
    this.setCarouselHeight();
    this.setupEventListeners();
    this.initializeModalListeners();
    this.initializeCheckboxListeners();
    // Ensure  totals are calculated so compare-at is correct on load
    try {
      this.calcTotalPrice();
    } catch (e) {}
    if (this.toggleVat) {
      this.toggleVat.addEventListener('change', () => {
        this.calcTotalPrice();
      });
    }
    this.colabsableContentBtn.addEventListener('click', () => {
      this.colabsableContentBtn.classList.toggle('active');
      this.orderSummaryBlock.querySelector('.prices__discription').classList.toggle('visiable');
    });
  }

  handleRestOffers(totalQuantity) {
    const maximumQuantity = this.productOffers[this.productOffers.length - 2]
      .querySelector('.product_offer__quantity')
      .innerText.split('-');
    if (totalQuantity === 0 || totalQuantity >= maximumQuantity[0]) this.restOfferProduct.classList.add('d-none');
    else {
      this.restOfferProduct.classList.remove('d-none');
      const nextOffer = this.querySelector('.product_offers__container .active_product__offer').nextElementSibling;
      const nextOfferQuantity = nextOffer.querySelector('.product_offer__quantity').innerText.split('-');
      const nextOfferPercesnt = nextOffer.querySelector('.product_offer__saving').innerText;
      const restOfferProductContent = this.restOfferProduct.querySelectorAll('span');
      restOfferProductContent[0].innerText = nextOfferQuantity[0] - totalQuantity + ' more';
      restOfferProductContent[1].innerText = nextOfferPercesnt;
    }
  }
  calcTotalPrice() {
    let discount = 0;
    let currentTotalPrice = 0;
    let previosTotalPrice = 0;
    const totalLogosPrice = +this.querySelector('.product__prices').getAttribute('logos-price') || 0;
    const totalOneTimeFees = +this.getAttribute('total-one-time-fees') || 0;
    const activeOffer = this.querySelector('.product_offers_parent__body .active_product__offer');
    const originalLogoPrice = +this.querySelector('.product__prices').getAttribute('original-logos-price') || 0;
    if (activeOffer) {
      discount = +activeOffer.querySelector('.discount__price').getAttribute('data-discount');
    }
    this.allVariantBlocks.forEach((el) => {
      previosTotalPrice +=
        +el.querySelector('.quantity__selcetor input').value * +el.querySelector('.variant__price span').innerText;
    });
    currentTotalPrice = previosTotalPrice - parseFloat((previosTotalPrice * discount).toFixed(2));
    const calculatePriceWithVat = (price, includeVat) => (includeVat ? price * 1.2 : price);

    const currentTotalWithVat = calculatePriceWithVat(currentTotalPrice, this.toggleVat?.checked);
    const totalLogosWithVat = calculatePriceWithVat(totalLogosPrice, this.toggleVat?.checked);
    const totalOneTimeFeesWithVat = calculatePriceWithVat(totalOneTimeFees, this.toggleVat?.checked);
    const previousTotalWithVat = calculatePriceWithVat(previosTotalPrice, this.toggleVat?.checked);
    const originalLogoWithVat = calculatePriceWithVat(originalLogoPrice, this.toggleVat?.checked);

    this.currentTotalPrice.innerText = (currentTotalWithVat + totalLogosWithVat + totalOneTimeFeesWithVat).toFixed(2);
    this.prevTotalPrice.innerText = (previousTotalWithVat + originalLogoWithVat + totalOneTimeFeesWithVat).toFixed(2);

    this.totalSaving.innerText = (
      previousTotalWithVat +
      originalLogoWithVat +
      totalOneTimeFeesWithVat -
      (currentTotalWithVat + totalLogosWithVat + totalOneTimeFeesWithVat)
    ).toFixed(2);
    const currentVal = parseFloat(this.currentTotalPrice.innerText);
    const previousVal = parseFloat(this.prevTotalPrice.innerText);
    if (!Number.isNaN(currentVal) && !Number.isNaN(previousVal) && previousVal > currentVal) {
      this.prevTotalPrice.closest('.prev__price').classList.remove('d-none');
    } else {
      this.prevTotalPrice.closest('.prev__price').classList.add('d-none');
    }
    this.querySelector('.product__prices').setAttribute('prev-total-price', previosTotalPrice);
    this.querySelector('.product__prices').setAttribute('current-total-price', currentTotalPrice);

    this.orderSummaryBlock.querySelector('.product__costs span span').innerText = currentTotalPrice.toFixed(2);

    // Update logo costs
    const logoCostsElement = this.orderSummaryBlock.querySelector('.logo__costs span span');
    if (logoCostsElement) {
      logoCostsElement.innerText = parseFloat(totalLogosPrice).toFixed(2);
    }

    // Update one-time fees
    const oneTimeFeesElement = this.orderSummaryBlock.querySelector('.one_time_fees__costs span span');
    if (oneTimeFeesElement) {
      oneTimeFeesElement.innerText = parseFloat(totalOneTimeFees).toFixed(2);
    }

    // Update totals (including logo costs and one-time fees)
    const totalWithoutVat = currentTotalPrice + totalLogosPrice + totalOneTimeFees;
    const totalVat = totalWithoutVat * 0.2;

    this.orderSummaryBlock.querySelector('.vat__costs span span').innerText = totalVat.toFixed(2);
    this.orderSummaryBlock.querySelector('.without_vat__costs span span').innerText = totalWithoutVat.toFixed(2);
  }

  initializeCheckboxListeners() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this, checkbox));
    });
  }
  initializeCheckboxListenersFirstTime() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }
  handleCheckboxChange(checkbox) {
    this.updateTheActiveColorSizes(checkbox);
    this.updateMedia(checkbox.getAttribute('featured-id'), checkbox.checked, checkbox.getAttribute('data-variant-id'));
    this.resetInpiuts(checkbox.value, checkbox.checked);
    this.calcTotalPrice();
  }
  initializeModalListeners() {
    const modalConfig = [
      { btn: this.sizesModalBtn, modal: this.sizesModal },
      { btn: this.sizesCloseBtn, modal: this.sizesModal },
    ];
    if (this.pricesCustomizationModalBtn) {
      modalConfig.push({
        btn: this.pricesCustomizationModalBtn,
        modal: this.pricesCustomizationModal,
        isPriceModal: true,
      });
      modalConfig.push({
        btn: this.pricesCloseBtn,
        modal: this.pricesCustomizationModal,
      });
    }
    if (this.artworkModalBtn) {
      modalConfig.push({
        btn: this.artworkModalBtn,
        modal: this.artworkModal,
      });
      modalConfig.push({
        btn: this.artworkCloseBtn,
        modal: this.artworkModal,
      });
    }
    if (this.exestingLogosPopupBtn) {
      modalConfig.push({
        btn: this.exestingLogosPopupBtn,
        modal: this.exestingLogosPopup,
      });
      modalConfig.push({
        btn: this.exestingLogosPopupCloseBtn,
        modal: this.exestingLogosPopup,
      });
    }
    modalConfig.forEach(({ btn, modal, isPriceModal = false }) => {
      btn.addEventListener('click', this.toggleModal.bind(this, modal, isPriceModal, null));
    });

    this.overlay.addEventListener('click', this.toggleModal.bind(this, null, null, true));
  }
  toggleModal(modal, isPriceModal, isOverlay) {
    if (isOverlay) {
      this.pricesCustomizationModal.classList.remove('show');
      this.sizesModal.classList.remove('show');
      if (this.artworkModal) this.artworkModal.classList.remove('show');
      this.overlay.classList.remove('show');
      document.body.style.overflow = 'auto';
      return;
    }

    if (isPriceModal) {
      setTimeout(() => {
        this.logSpaceBetweenFirstOfferAndParent();
      }, 0);
    }

    if (!document.body.contains(this.overlay)) {
      document.body.appendChild(this.overlay);
    }

    modal.classList.toggle('show');
    this.overlay.classList.toggle('show');

    document.body.style.overflow = modal.classList.contains('show') ? 'hidden' : 'auto';
  }
  logSpaceBetweenFirstOfferAndParent() {
    const firstOffer = this.modalProductOffers;
    const parent = firstOffer.closest('.product_offers__body');

    const firstOfferRect = firstOffer.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    const space = firstOfferRect.left - parentRect.left;
    const offerBodyheaders = this.querySelectorAll('.product_offers_body__header');
    offerBodyheaders.forEach((el) => {
      el.style.paddingLeft = space + 'px';
    });
  }
  updateMedia(featureId, checkboxChecked) {
    if (checkboxChecked === true) {
      const mediaList = document.querySelector('.product__media-list');
      let activeMedia = null;
      mediaList.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('active');
        if (element.getAttribute('data-media-id') === featureId) activeMedia = element;
      });
      if (activeMedia) activeMedia.classList.add('active');
      const swiperWrappers = document.querySelectorAll('.product__media-wrapper');
      swiperWrappers.forEach((elem) => {
        if (elem.querySelector('.js-media-list')) {
          elem
            .querySelector('.js-media-list')
            .swiper.slideTo(elem.querySelector('.js-media-list').swiper.slides.indexOf(activeMedia));
        }
      });
    }
  }
  initializeFlickity(el) {
    if (el) {
      this.carousel = new Flickity(el, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        prevNextButtons: true,
      });
      setTimeout(() => {
        this.carousel.resize();
      }, 10);
    }
  }
  updateTheActiveColorSizes(el) {
    let color = null;
    const checked = el.checked;
    const colorAttr = el.value;
    this.colorSizes.forEach((el2) => {
      if (colorAttr === el2.getAttribute('data-sizes-color')) {
        if (checked === true) {
          if (el2.parentElement) {
            el2.parentElement.prepend(el2);
          }
          el2.style.display = 'block';
          this.initializeFlickity(el2.querySelector('.product-form__controls-group '));
        } else el2.style.display = 'none';
      }
    });
    const newColorSizes = this.querySelectorAll('.color_sizes__wrapper .size-block-list');
    if (newColorSizes) {
      for (let i = 0; i < newColorSizes.length; i++) {
        if (newColorSizes[i].style.display === 'block') {
          {
            color = newColorSizes[i].getAttribute('data-sizes-color');
            break;
          }
        }
      }
    }

    if (color) {
      this.selectedColour.querySelector('span').innerText = `${color}`;
      this.selectedColour.style.display = 'unset';
      this.colorSizesBlock.classList.remove('d-none');
    } else {
      this.selectedColour.style.display = 'none';
      if (this.colorSizesBlock) this.colorSizesBlock.classList.add('d-none');
    }
  }
  setMaxValuesForInputs() {
    this.allInputs.forEach((el) => {
      el.max = +el
        .closest('.quantity__selcetor')
        .parentElement.querySelector('.product__inventory')
        .getAttribute('data-quantity');
    });
  }
  initializeElements() {
    this.slides = this.querySelectorAll('.product__quantity');
    this.flickityViewport = this.querySelector('.product-form__controls-group .flickity-viewport');
    this.quantitySelectors = this.querySelectorAll('.quantity__selcetor');
  }

  setCarouselHeight() {
    let maxHeight = 0;

    this.slides.forEach((slide) => {
      const slideHeight = slide.scrollHeight;
      if (slideHeight > maxHeight) {
        maxHeight = slideHeight;
      }
    });

    this.slides.forEach((slide) => {
      slide.style.height = `${maxHeight}px`;
    });

    if (this.flickityViewport) {
      this.flickityViewport.style.height = `${maxHeight}px`;
    }
  }
  getTotalQuantityForEachblock(el) {
    let quantity = 0;
    const inputs = el.querySelectorAll("input[type='number']");
    inputs.forEach((elem) => {
      quantity += +elem.value;
    });
    if (quantity !== 0) el.querySelector('.quantity__selected').innerText = quantity + ' Selected';
    else el.querySelector('.quantity__selected').innerText = 0;
  }
  getTotalQuantity() {
    let toatlQuantity = 0;
    const inputs = this.querySelectorAll(".color_sizes__wrapper input[type='number']");
    inputs.forEach((elem) => {
      toatlQuantity += +elem.value;
    });
    this.querySelector('.color__sizes').setAttribute('data-quantity', toatlQuantity);
    if (toatlQuantity > 0 && this.customLogoBlock) this.customLogoBlock.classList.remove('d-none');
    else if (toatlQuantity === 0 && this.customLogoBlock) this.customLogoBlock.classList.add('d-none');
    return toatlQuantity;
  }
  resetInpiuts(colorAttr, checked) {
    if (checked === false) {
      this.colorSizes.forEach((el2) => {
        if (colorAttr === el2.getAttribute('data-sizes-color')) {
          el2.querySelectorAll("input[type='number']").forEach((el) => {
            el.value = 0;
          });
          this.getTotalQuantityForEachblock(el2.closest('.size-block-list'));
          this.setActiveUpsells(this.getTotalQuantity());
          this.calcTotalPrice();
          this.handleRestOffers(this.getTotalQuantity());
        }
      });
    }
  }
  setActiveUpsells(totalQuantity) {
    let quantitoes = [];
    this.productOffers.forEach((el) => {
      el.classList.remove('active_product__offer');
    });
    if (totalQuantity === 0) {
      this.productOffers.forEach((el) => {
        el.classList.remove('active_product__offer');
      });
      return;
    }
    this.productOffers.forEach((el, idx) => {
      if (idx !== this.productOffers.length - 1) {
        quantitoes = el.querySelector('.product_offer__quantity').innerText.split('-');
      } else if (idx === this.productOffers.length - 1) {
        quantitoes = el.querySelector('.product_offer__quantity').innerText.split('+');
        quantitoes[1] = 999999;
      }
      if (totalQuantity >= quantitoes[0] && totalQuantity <= quantitoes[1]) {
        el.classList.add('active_product__offer');
      }
    });
  }
  setupEventListeners() {
    window.addEventListener('resize', this.setCarouselHeight.bind(this));

    this.quantitySelectors.forEach((selector) => {
      const minusBtn = selector.querySelector('.minus__btn');
      const plusBtn = selector.querySelector('.plus__btn');
      const input = selector.querySelector("input[type='number']");

      const updateButtonStates = () => {
        let maxValue = parseInt(input.getAttribute('max'), 10);
        const value = parseInt(input.value) || 0;

        minusBtn.disabled = value <= 0;
        plusBtn.disabled = value >= maxValue;
      };

      const handleMinusClick = (event) => {
        event.preventDefault();
        let value = parseInt(input.value) || 0;
        if (value > 0) {
          input.value = value - 1;
          updateButtonStates();
        }
        this.getTotalQuantityForEachblock(selector.closest('.size-block-list'));
        this.setActiveUpsells(this.getTotalQuantity());
        this.calcTotalPrice();
        this.handleRestOffers(this.getTotalQuantity());
      };

      const handlePlusClick = (event) => {
        event.preventDefault();
        let value = parseInt(input.value) || 0;
        let maxValue = parseInt(input.getAttribute('max'), 10);

        if (value < maxValue) {
          input.value = value + 1;
          updateButtonStates();
        }
        // console.log(selector.closest(".size-block-list"));
        this.getTotalQuantityForEachblock(selector.closest('.size-block-list'));
        this.setActiveUpsells(this.getTotalQuantity());
        this.calcTotalPrice();
        this.handleRestOffers(this.getTotalQuantity());
      };

      const handleInputChange = () => {
        let value = parseInt(input.value) || 0;
        let maxValue = parseInt(input.getAttribute('max'), 10);

        if (value < 0) {
          input.value = 0;
        } else if (value > maxValue) {
          input.value = maxValue;
        }
        this.getTotalQuantityForEachblock(selector.closest('.size-block-list'));
        this.setActiveUpsells(this.getTotalQuantity());
        this.calcTotalPrice();
        this.handleRestOffers(this.getTotalQuantity());

        updateButtonStates();
      };

      updateButtonStates();

      minusBtn.addEventListener('click', handleMinusClick);
      plusBtn.addEventListener('click', handlePlusClick);
      input.addEventListener('input', handleInputChange);
    });
  }
}

customElements.define('variant-selector', VariantSelector);

class deliveryDates extends HTMLElement {
  constructor() {
    super();
    this.deleveryDateWithoutLogos = this.querySelector('.arrival_without__logo .bolder');
    this.deleveryDateWithLogos = this.querySelector('.arrival_with__logo .bolder');
    this.orderWithen = this.querySelector('.order__within span');
  }
  connectedCallback() {
    this.intiateDeleveryDates();
  }
  formatDateWithOffset(offsetDays) {
    const date = new Date();
    let addedDays = 0;

    while (addedDays < offsetDays) {
      date.setDate(date.getDate() + 1);
      const dayOfWeek = date.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays++;
      }
    }
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const weekday = weekdays[date.getDay()];
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const ordinal = (n) => {
      const s = ['th', 'st', 'nd', 'rd'];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    return `${weekday} ${ordinal(day)} ${month}`;
  }
  timeUntil6PM() {
    const time__now = this.querySelector('.time__now');
    const timeNowValue = time__now?.textContent?.trim();
    const formattedTimeNow = timeNowValue.replace(/^(\d{4})-(\d{2})-(\d{2})-(\d{2})-(\d{2})$/, '$1-$2-$3T$4:$5');
    const now = new Date(formattedTimeNow);
    const sixPM = new Date(now);
    sixPM.setHours(18, 0, 0, 0);

    let diffMs = sixPM - now;

    if (diffMs < 0) {
      sixPM.setDate(sixPM.getDate() + 1);
      diffMs = sixPM - now;
    }

    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${diffHrs}hrs ${diffMins} mins`;
  }
  intiateDeleveryDates() {
    const time__now = this.querySelector('.time__now');
    const timeNowValue = time__now?.textContent?.trim();
    const formattedTimeNow = timeNowValue.replace(/^(\d{4})-(\d{2})-(\d{2})-(\d{2})-(\d{2})$/, '$1-$2-$3T$4:$5');
    const now = new Date(formattedTimeNow);
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    if (currentHour > 18 || (currentHour === 18 && currentMinute >= 0)) {
      this.deleveryDateWithLogos.innerText = this.formatDateWithOffset(11);
      this.deleveryDateWithoutLogos.innerText = this.formatDateWithOffset(4);
    } else {
      this.deleveryDateWithLogos.innerText = this.formatDateWithOffset(10);
      this.deleveryDateWithoutLogos.innerText = this.formatDateWithOffset(3);
    }
    this.orderWithen.innerText = this.timeUntil6PM();
  }
}
customElements.define('delivery-dates', deliveryDates);

class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll('.field--pass');

    passwordField.forEach((el) => {
      const input = el.querySelector('input');
      const btnWrapper = el.querySelector('.button-pass-visibility');
      const btnOpen = el.querySelector('.icon-eye-close');
      const btnClose = el.querySelector('.icon-eye');

      input.addEventListener('input', () => {
        input.value !== '' ? (btnWrapper.style.display = 'block') : (btnWrapper.style.display = 'none');
      });

      btnOpen.addEventListener('click', () => {
        input.type = 'text';
        btnOpen.style.display = 'none';
        btnClose.style.display = 'block';
      });

      btnClose.addEventListener('click', () => {
        input.type = 'password';
        btnOpen.style.display = 'block';
        btnClose.style.display = 'none';
      });
    });
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          /* Color swatches */
          const generateSrcset = (image, widths = []) => {
            const fileUrl = new URL(image['src']);
            return widths
              .filter((width) => width <= image['width'])
              .map((width) => {
                fileUrl.searchParams.set('width', width.toString());
                return `${fileUrl.href} ${width}w`;
              })
              .join(', ');
          };

          const createImageElement = (image, classes, sizes, productTitle) => {
            const previewImage = image['preview_image'];
            const newImage = new Image(previewImage['width'], previewImage['height']);
            newImage.className = classes;
            newImage.alt = image['alt'] || productTitle;
            newImage.sizes = sizes;
            newImage.src = previewImage['src'];
            newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
            newImage.loading = 'lazy';
            return newImage;
          };

          const checkSwatches = () => {
            document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
              wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                input.addEventListener('click', (event) => {
                  const primaryImage = wrapper.querySelector('.media--first');
                  const secondaryImage = wrapper.querySelector('.media--second');
                  const handleProduct = wrapper.dataset.product;

                  if (event.currentTarget.checked && primaryImage) {
                    wrapper
                      .querySelector('.js-color-swatches-link')
                      .setAttribute('href', event.currentTarget.dataset.variantLink);
                    const currentColor = event.currentTarget.value;

                    jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                      const variant = product.variants.filter(
                        (item) => item.featured_media != null && item.options.includes(currentColor)
                      )[0];

                      if (variant) {
                        const newPrimaryImage = createImageElement(
                          variant['featured_media'],
                          primaryImage.className,
                          primaryImage.sizes,
                          product.title
                        );

                        if (newPrimaryImage.src !== primaryImage.src) {
                          let flag = false;
                          if (secondaryImage) {
                            const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                            const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                            if (secondaryImagePathname == newPrimaryImagePathname) {
                              primaryImage.remove();
                              secondaryImage.classList.remove('media--second');
                              secondaryImage.classList.add('media--first');
                              flag = true;
                            }
                          }
                          if (flag == false) {
                            primaryImage.animate(
                              { opacity: [1, 0] },
                              {
                                duration: 200,
                                easing: 'ease-in',
                                fill: 'forwards',
                              }
                            ).finished;
                            setTimeout(function () {
                              primaryImage.replaceWith(newPrimaryImage);
                              newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                              if (secondaryImage) {
                                secondaryImage.remove();
                              }
                            }, 200);
                          }
                        }
                      }
                    });
                  }
                });
              });
            });
          };

          checkSwatches();

          const calcTop = (section) => {
            const imageWrapper = section.querySelectorAll('.card__inner');
            let top = 0;

            if (imageWrapper) {
              top = imageWrapper[0].offsetHeight / 2;
            } else {
              top = 50;
            }

            return top;
          };

          const initSlider = () => {
            let mobileLayout = 1;
            if (this.dataset.mobileLayout) {
              mobileLayout = this.dataset.mobileLayout;
            }
            let slider = new Swiper(this.querySelector('.js-recommendation-swiper'), {
              slidesPerView: mobileLayout,
              slidesPerGroup: 1,
              spaceBetween: 8,
              speed: 500,
              navigation: {
                nextEl: this.querySelector('.product-recommendations__slider-nav .swiper-button-next'),
                prevEl: this.querySelector('.product-recommendations__slider-nav .swiper-button-prev'),
              },
              breakpoints: {
                576: {
                  slidesPerView: 2,
                  slidesPerGroup: 2,
                },
                750: {
                  slidesPerView: 3,
                  slidesPerGroup: 3,
                  spaceBetween: 24,
                },
              },
            });
          };

          const initSection = () => {
            const section = this;

            const sectionResizeObserver = new ResizeObserver((entries) => {
              const [entry] = entries;
              let top = calcTop(section);
              if (section.querySelector('.product-recommendations__slider-nav'))
                section.querySelector('.product-recommendations__slider-nav').style.top = top + 'px';
            });

            sectionResizeObserver.observe(section);

            initSlider();
          };

          initSection();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

(function () {
  const initHeaderOverlay = () => {
    const main = document.getElementById('MainContent');
    const sections = main.querySelectorAll('.shopify-section');
    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector('.section--has-overlay');
      const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group');
      const header = document.querySelector('.shopify-section-header');

      if (sectionFirstChild) {
        if (sectionFirstChild.classList.contains('section--has-overlay')) {
          if (headerGroupSections[headerGroupSections.length - 1] === header) {
            sections[0].classList.remove('not-margin');

            if (sectionFirstChild.classList.contains('section--header-light')) {
              header.classList.add('color-background-overlay');
            } else {
              header.classList.remove('color-background-overlay');
            }
          } else {
            sections[0].classList.add('not-margin');
            header.classList.remove('color-background-overlay');
          }
        } else {
          sections[0].classList.remove('not-margin');

          header.classList.remove('color-background-overlay');
        }
      } else {
        header.classList.remove('color-background-overlay');
      }
    }
  };

  initHeaderOverlay();

  document.addEventListener('shopify:section:load', initHeaderOverlay);
  document.addEventListener('shopify:section:unload', initHeaderOverlay);
  document.addEventListener('shopify:section:reorder', initHeaderOverlay);
})();

function formatMoney(cents, format = '') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || theme.moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

const initUnderlinedTitles = () => {
  let sectionTitles = document.querySelectorAll(
    '.shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-footer-group) .title--rounded'
  );

  if (sectionTitles.length > 0) {
    sectionTitles.forEach((title) => {
      const sectionResizeObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        let xs, s, m, l, xl;

        if (document.body.clientWidth < 1600) {
          xs = 95;
          s = 160;
          m = 280;
          l = 380;
          xl = 520;
        } else {
          xs = 95;
          s = 200;
          m = 360;
          l = 450;
          xl = 620;
        }

        entry.target.querySelectorAll('span[style="text-decoration:underline"]').forEach((span) => {
          const titleWidth = span.getBoundingClientRect().width;
          span.classList.remove(
            'title--rounded-xs',
            'title--rounded-s',
            'title--rounded-m',
            'title--rounded-l',
            'title--rounded-xl',
            'title--rounded-xxl'
          );
          if (titleWidth < xs) {
            span.classList.add('title--rounded-xs');
          } else if (titleWidth < s) {
            span.classList.add('title--rounded-s');
          } else if (titleWidth < m) {
            span.classList.add('title--rounded-m');
          } else if (titleWidth < l) {
            span.classList.add('title--rounded-l');
          } else if (titleWidth < xl) {
            span.classList.add('title--rounded-xl');
          } else {
            span.classList.add('title--rounded-xxl');
          }
        });
      });

      sectionResizeObserver.observe(title);
    });
  }
};
